__webpack_require__.p = "/soc-partner/";